import { MenuGroup } from '../../../models/menu-item.model';
import { Roles } from '../../../models/roles';
import { TenantOptions } from '../../../models/tenant-options';

const CLIENT_ALLOWED_ROLES = [
  Roles.CREDIT_ANALYST,
  Roles.SALES_REPRESENTATIVE,
  Roles.COMMERCIAL_MANAGER,
  Roles.REGISTRATION_AGENT,
];

const CREDIT_ANALYSIS_ALLOWED_ROLES = [Roles.CREDIT_ANALYST];

export const CREDIT_OVERVIEW_ALLOWED_ROLES = [
  Roles.CREDIT_ANALYST,
  Roles.COMMERCIAL_MANAGER,
  Roles.REGISTRATION_AGENT,
  Roles.FORMALIZATION_AGENT,
  Roles.OPERATION_REQUESTER,
];

const PREFIN_ALLOWED_ROLES = [Roles.OPERATION_REQUESTER];

const LAUDO_ALLOWED_ROLES = [Roles.OPERATION_REQUESTER];

export const PROPOSAL_ALLOWED_ROLES = [
  Roles.CREDIT_ANALYST,
  Roles.SALES_REPRESENTATIVE,
  Roles.COMMERCIAL_MANAGER,
  Roles.REGISTRATION_AGENT,
];

const FORMALIZATION_ALLOWED_ROLES = [Roles.FORMALIZATION_AGENT];

const OPERATIONS_REGISTER_ALLOWED_ROLES = [Roles.OPERATION_REQUESTER];

const BILLING_DASHBOARD_ALLOWED_ROLES = [Roles.ANALYST];

const MONITORED_OPERATIONS_ALLOWED_ROLES = [Roles.ANALYST];

const CONSUMPTION_ALLOWED_ROLES = [Roles.CONSUMPTION_VIEWER];

export const MENU_GROUPS = [
  {
    label: 'Carteira',
    visible: () => true,
    items: [
      {
        label: 'Cadastro',
        icon: 'user-pen',
        route: '/cliente',
        requiredRoles: CLIENT_ALLOWED_ROLES,
        amplitudeMessage: 'Acessou Cadastro pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Carteira',
          Origem: 'Plataforma nova',
        },
        visible: () => true,
        isDisabled: (ctx) => !CLIENT_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
    ],
  },

  {
    label: 'Crédito',
    visible: (ctx) =>
      ctx.shouldShowCreditModule() ||
      ctx.hasTenantOption(TenantOptions.CREDIT_NEW_CREDIT_ANALYSIS) ||
      ctx.hasTenantOption(TenantOptions.CREDIT_PROPOSAL_MANAGEMENT) ||
      ctx.hasTenantOption(TenantOptions.CREDIT_FORMALIZATION),
    items: [
      {
        label: 'Gerencial',
        icon: 'chart-mixed',
        route: '/gerencial',
        requiredRoles: CREDIT_OVERVIEW_ALLOWED_ROLES,
        requiredTenantOptions: [
          TenantOptions.CREDIT_NEW_CREDIT_ANALYSIS,
          TenantOptions.CREDIT_PROPOSAL_MANAGEMENT,
          TenantOptions.CREDIT_FORMALIZATION,
          TenantOptions.RISK_MANAGEMENT_AREA_ANALYSIS,
          TenantOptions.RISK_MANAGEMENT_HISTORICAL_ANALYSIS,
        ],
        requiredTenantOptionsValidationMode: 'some',
        amplitudeMessage: 'Acessou Gerencial pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Crédito',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) =>
          ctx.hasTenantOption(TenantOptions.CREDIT_NEW_CREDIT_ANALYSIS) ||
          ctx.hasTenantOption(TenantOptions.CREDIT_PROPOSAL_MANAGEMENT) ||
          ctx.hasTenantOption(TenantOptions.CREDIT_FORMALIZATION) ||
          ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_AREA_ANALYSIS) ||
          ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_HISTORICAL_ANALYSIS),
        isDisabled: (ctx) => !CREDIT_OVERVIEW_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Análise de crédito',
        icon: 'user-magnifying-glass',
        route: '/analise-de-credito',
        requiredRoles: CREDIT_ANALYSIS_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.CREDIT_NEW_CREDIT_ANALYSIS],
        amplitudeMessage: 'Acessou Análise de Crédito pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Crédito',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.CREDIT_NEW_CREDIT_ANALYSIS),
        isDisabled: (ctx) => !CREDIT_ANALYSIS_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Pré-financiamento',
        icon: 'map-location-dot',
        externalUrl: '/gestao-de-riscos/analise-de-credito/pre-financiamento',
        requiredRoles: PREFIN_ALLOWED_ROLES,
        requiredTenantOptions: [
          TenantOptions.RISK_MANAGEMENT_AREA_ANALYSIS,
          TenantOptions.RISK_MANAGEMENT_HISTORICAL_ANALYSIS,
        ],
        requiredTenantOptionsValidationMode: 'some',
        amplitudeMessage: 'Acessou Pré-financiamento pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Crédito',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) =>
          ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_AREA_ANALYSIS) ||
          ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_HISTORICAL_ANALYSIS),
        isDisabled: (ctx) => !PREFIN_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Gestão de propostas',
        icon: 'file-circle-plus',
        route: '/gestao-de-proposta',
        requiredRoles: PROPOSAL_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.CREDIT_PROPOSAL_MANAGEMENT],
        amplitudeMessage: 'Acessou Gestão de proposta pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Crédito',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.CREDIT_PROPOSAL_MANAGEMENT),
        isDisabled: (ctx) => !PROPOSAL_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Formalização',
        icon: 'memo-pad',
        iconSize: '20px',
        route: '/formalizacao',
        requiredRoles: FORMALIZATION_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.CREDIT_FORMALIZATION],
        amplitudeMessage: 'Acessou a Formalização pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Crédito',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.CREDIT_FORMALIZATION),
        isDisabled: (ctx) => !FORMALIZATION_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
    ],
  },

  {
    label: 'Cobrança',
    visible: (ctx) =>
      ctx.shouldShowBillingModule() ||
      ctx.hasTenantOption(TenantOptions.BILLING_ANALYST_NEW_DASHBOARD) ||
      ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_MONITORED_OPERATIONS) ||
      ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_OPERATIONS_REGISTER) ||
      ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_LAUDO_TECNICO),
    items: [
      {
        label: 'Cadastro de operações',
        icon: 'file-circle-plus',
        externalUrl: '/gestao-de-riscos/cobranca/cadastro-de-operacoes',
        requiredRoles: OPERATIONS_REGISTER_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.RISK_MANAGEMENT_OPERATIONS_REGISTER],
        amplitudeMessage: 'Acessou Cadastro de operações pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Cobrança',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_OPERATIONS_REGISTER),
        isDisabled: (ctx) => !OPERATIONS_REGISTER_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Operações monitoradas',
        icon: 'satellite',
        externalUrl: '/gestao-de-riscos/cobranca/operacoes-monitoradas/v2',
        requiredRoles: MONITORED_OPERATIONS_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.RISK_MANAGEMENT_MONITORED_OPERATIONS],
        amplitudeMessage: 'Acessou Operações monitoradas pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Cobrança',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_MONITORED_OPERATIONS),
        isDisabled: (ctx) => !MONITORED_OPERATIONS_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Painel de indicadores',
        icon: 'chart-mixed',
        route: '/painel-indicadores',
        requiredRoles: BILLING_DASHBOARD_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.BILLING_ANALYST_NEW_DASHBOARD],
        amplitudeMessage: 'Acessou Painel de indicadores pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Cobrança',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.BILLING_ANALYST_NEW_DASHBOARD),
        isDisabled: (ctx) => !BILLING_DASHBOARD_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
      {
        label: 'Laudo técnico',
        icon: 'file-contract',
        route: '/laudos',
        requiredRoles: LAUDO_ALLOWED_ROLES,
        requiredTenantOptions: [TenantOptions.RISK_MANAGEMENT_LAUDO_TECNICO],
        amplitudeMessage: 'Acessou Laudo técnico pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Cobrança',
          Origem: 'Plataforma nova',
        },
        visible: (ctx) => ctx.hasTenantOption(TenantOptions.RISK_MANAGEMENT_LAUDO_TECNICO),
        isDisabled: (ctx) => !LAUDO_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
    ],
  },

  {
    label: 'Configurações',
    visible: () => true,
    items: [
      {
        label: 'Divisões',
        icon: 'users-rectangle',
        externalUrl: '/configuracoes/divisoes',
        requiredRoles: [Roles.ADMIN],
        amplitudeMessage: 'Acessou Divisões pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Configurações',
          Origem: 'Plataforma nova',
        },
        isDisabled: (ctx) => !ctx.hasRole(Roles.ADMIN),
      },
      {
        label: 'Usuários',
        icon: 'user',
        externalUrl: '/configuracoes/usuarios',
        requiredRoles: [Roles.MANAGER],
        amplitudeMessage: 'Acessou Usuários pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Configurações',
          Origem: 'Plataforma nova',
        },
        isDisabled: (ctx) => !ctx.hasRole(Roles.MANAGER),
      },
      {
        label: 'Consumo',
        icon: 'chart-line',
        iconStyle: 'light',
        route: '/consumo',
        requiredRoles: CONSUMPTION_ALLOWED_ROLES,
        amplitudeMessage: 'Acessou Consumo pelo Menu lateral',
        amplitudeOptions: {
          Sessão: 'Configurações',
          Origem: 'Plataforma nova',
        },
        visible: () => true,
        isDisabled: (ctx) => !CONSUMPTION_ALLOWED_ROLES.some((role) => ctx.hasRole(role)),
      },
    ],
  },
] as const satisfies readonly MenuGroup[];
